import { IGroupedComboBoxGroup } from 'grouped-combobox-core';
import { findFontByKey } from '../common/findFontByKey';
import { setFontPinnedState } from '../common/pinning';
import { findFontIndex } from './findFontIndex';

const pinnedGroupIndex = 1;

export function addFontToPinnedGroup(
    groups: IGroupedComboBoxGroup[],
    fontKey: string
): IGroupedComboBoxGroup[] {
    if (groups.length < 2) {
        throw new Error('"groups" must have at least two elements.');
    }

    // Pinned group is always the second group
    const pinnedGroup = groups[pinnedGroupIndex];

    // check if the specified font key is already pinned
    const existingItemIndex = findFontIndex(fontKey, pinnedGroup);
    if (existingItemIndex !== -1) {
        return groups;
    }

    // look up the font item from the All Fonts section
    const fontItem = findFontByKey(fontKey, groups[groups.length - 1].items);
    if (!fontItem) {
        return groups;
    }

    // We want to maintain pinned group in alphabetically sorted order.
    // Hence we have to insert the new font at the correct place.
    const insertIndex = pinnedGroup.items.findIndex(
        (item) => fontItem.itemKey.localeCompare(item.itemKey) <= 0
    );

    if (insertIndex === -1) {
        pinnedGroup.items.push(fontItem);
    } else {
        pinnedGroup.items.splice(insertIndex, 0, fontItem);
    }

    // now mark the font's state as pinned
    setFontPinnedState(fontItem, true);

    // clone the pinned items to trigger re-render within Pinned section
    pinnedGroup.items = pinnedGroup.items.slice();

    // clone the entire groups to trigger re-render in react native font picker
    return groups.slice();
}

export function removeFontFromPinnedGroup(
    groups: IGroupedComboBoxGroup[],
    fontKey: string
): IGroupedComboBoxGroup[] {
    if (groups.length < 2) {
        throw new Error('"groups" must have at least two elements.');
    }

    // Pinned group is always the second group
    const pinnedGroup = groups[pinnedGroupIndex];

    // check if the specified font key is already pinned
    const existingItemIndex = findFontIndex(fontKey, pinnedGroup);
    if (existingItemIndex === -1) {
        return groups;
    }

    // look up the font item from the All Fonts section
    const fontItem = findFontByKey(fontKey, groups[groups.length - 1].items);
    if (!fontItem) {
        return groups;
    }

    // now mark the font's state as unpinned
    setFontPinnedState(fontItem, false);

    pinnedGroup.items.splice(existingItemIndex, 1);

    // clone the pinned items to trigger re-render within Pinned section
    pinnedGroup.items = pinnedGroup.items.slice();

    // clone the entire groups to trigger re-render in react native font picker
    return groups.slice();
}
